export default __webpack_public_path__ + "static/media/programasPacientesInicio.8ab5aeeb.svg";